const Colors = {
  periwinkle: '#9966ff',
  tealish: '#33cccc',
  lightTealish: '#43e4e4',
  degradStart: '#ab64f5',
  degradeEnd: '#8d85ee',
  paleGrey: '#f1f5f7',
  white: '#fff',
  slate: '#4a5365',
  darkSlate: '#180a33',
  bluishGrey: '#859099',
  blueyGrey: '#acbec7',
  cloudyBlue: '#cfdae1',
  lightGreyish: '#e0e7ec',
  greenishTeal: '#33cc99',
  greenishTealBg: '#e1f8f0',
  paleOrange: '#ff9966',
  paleOrangeLight: '#ffaa80',
  paleOrangeBg: '#fff0e8',
  periwinkleBlue: '#9999ff',
  brightLightBlue: '#33ccff',
  brightLightBlueBg: '#e1f8ff',
  sunYellow: '#ffcc33',
  salmon: '#ff6666',
  orchid: '#cc66cc',
  windowsBlue: '#3399cc',
  periwinkleStrong: '#9000ff',
  purpleGreyish: '#efd9ff',
  purple: '#9900ff',
  lightBlue: '#d6f5ff',
  darkBlue: '#1b0835',
  green: '#1ea074',
  rccLightBlue: '#e8f0f6',
  referralLightBlue: '#f1f5f7',
  rccDarkGreen: '#0e3d54',
  rccGreen: '#43a199',
  darkIndigo: '#190b3c',
  whatsAppGreen: '#25d366',
};

export default Colors;
